import React, { useState, useRef } from 'react';
import { useUser } from '../../../UserContext';

import { Box } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import FormControlLabel from '@mui/material/FormControlLabel';
import { uploadFile } from '../../../services/uploadService';
import { aws_base_path } from '../../../config/config';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import Tooltip from '@mui/material/Tooltip';

import { useAuth } from '../../../AuthContext';
import { useLocale } from '../../../i18n/LanguageContext';

export default function KitchenStatusPanel(props) {
  const { user } = useUser();
  const { auth } = useAuth();
  const { t } = useLocale();
  const [uploadStatus, setUploadStatus] = useState('');
  const fileInputRef = useRef(null);

  const kitchenProfilePicDimensions = { width: '100%', height: 180}
  const isKitchenSetupComplete = Boolean(
    props.kitchenData?.address &&
    props.kitchenData?.city &&
    props.kitchenData?.state &&
    props.kitchenData?.phoneNumber &&
    props.kitchenData?.latitude &&
    props.kitchenData?.longitude &&
    (props.kitchenData?.providesDelivery || props.kitchenData?.acceptsPickup) &&
    props.kitchenData?.menus &&
    props.kitchenData.menus.length > 0 &&
    props.kitchenData.menus.some((menu) =>
      menu.isActive &&
      menu.items &&
      menu.items.length > 0 &&
      menu.items.some((menuItem) => menuItem.isActive)
    ) &&
    user?.firstName &&
    user?.lastName &&
    user?.email &&
    user?.profilePic &&
    user?.selfIntroduction &&
    user?.chef?.complianceAcknowledgment
  );

  const handleFileChange = (event) => {

    if (!event.target.files[0]) {
      alert(t('kitchenStatusPanel.selectFile'));
      return;
    }

    handleUpload(event.target.files[0]);
  };

  const handleUpload = (selectedFile) => {

    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('metadata', JSON.stringify(
      { 
        chefId: props.kitchenData.chef?.id, 
        kitchenId: props.kitchenData.id, 
        menuItemId: 0, 
        pictureType: 'kitchenProfile'
      }
    ));

    uploadFile(formData, auth).then((response) => {
      if (response) {
        props.onDataChange({...props.kitchenData, profilePic: response.imageThumbUrl});
      } else {
        setUploadStatus(t('kitchenStatusPanel.uploadError'));
      }
    })
      .catch((error) => {
        console.error('Error uploading file:', error);
        setUploadStatus(t('kitchenStatusPanel.uploadError'));
      });
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  function toggleKitchenIsReady() {
      var kitchen = {...props.kitchenData, isReady: !props.kitchenData.isReady};
      props.onDataChange(kitchen);
    }

  return (
    <div>
      <div style={{ position: 'relative'}}>
                <img src={aws_base_path + props.kitchenData.profilePic} style={{ border: '0px solid lightgray', width: kitchenProfilePicDimensions.width, height: kitchenProfilePicDimensions.height, borderRadius: '4px'}}></img>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}} >
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                  />
                  <div style={{ position: 'absolute', top: '40%', left: '46%', display: 'flex', flexDirection: 'row'}}>
                    <Tooltip title={t('kitchenStatusPanel.changeProfilePicture')} placement="top-start">
                      <IconButton 
                          data-testid="upload-kitchen-pic" 
                          onClick={handleButtonClick}>
                          <CameraAltIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
                {uploadStatus && <p>{uploadStatus}</p>}
        </div>

        <div>
            <FormControlLabel
                value="isReady"
                control={<Checkbox checked={props.kitchenData.isReady} onChange={toggleKitchenIsReady} disabled={!isKitchenSetupComplete} />}
              label={t('kitchenStatusPanel.isReady')}
                labelPlacement="end"
            />
            <div style={{ marginBottom: 8, color: 'gray'}}>{t('kitchenStatusPanel.readyVisibilityNote')}</div>
        </div>
        
    </div>
  );
}